function HomeIcon({width, height, className}) {
	return (
		<>
            <span className={className}>
                <svg viewBox="0 0 512 512" width={width} height={height} className="fill-current"
                     xmlns="http://www.w3.org/2000/svg">
                    <path
	                    d="M 256.274 60.84 L 84.324 166.237 L 84.324 443.063 L 193.27 443.063 L 193.27 293.73 L 320.228 293.73 L 320.228 443.063 L 428.222 443.063 L 428.222 165.476 L 256.274 60.84 Z M 256.274 35.95 L 448.452 149.145 L 448.452 464.395 L 300 464.395 L 300 315.062 L 213.499 315.062 L 213.499 464.395 L 64.095 464.395 L 64.095 150.161 L 256.274 35.95 Z">
                    </path>
                </svg>
            </span>
		</>
	)
}

function SearchIcon({width, height, className}) {
	return (
		<>
            <span className={className}>
                <svg viewBox="0 0 512 512" width={width} height={height} xmlns="http://www.w3.org/2000/svg"
                     className="fill-current">
                    <path
	                    d="M349.714 347.937l93.714 109.969-16.254 13.969-93.969-109.969q-48.508 36.825-109.207 36.825-36.826 0-70.476-14.349t-57.905-38.603-38.603-57.905-14.349-70.476 14.349-70.476 38.603-57.905 57.905-38.603 70.476-14.349 70.476 14.349 57.905 38.603 38.603 57.905 14.349 70.476q0 37.841-14.73 71.619t-40.889 58.921zM224 377.397q43.428 0 80.254-21.461t58.286-58.286 21.461-80.254-21.461-80.254-58.286-58.285-80.254-21.46-80.254 21.46-58.285 58.285-21.46 80.254 21.46 80.254 58.285 58.286 80.254 21.461z"
	                    fillRule="evenodd"></path>
                </svg>
            </span>
		</>
	)
}

function CollectionIcon({width, height, className}) {
	return (
		<>
            <span className={className}>
                <svg viewBox="0 0 512 512" width={width} height={height} xmlns="http://www.w3.org/2000/svg"
                     className="fill-current">
                    <path
	                    d="M291.301 81.778l166.349 373.587-19.301 8.635-166.349-373.587zM64 463.746v-384h21.334v384h-21.334zM192 463.746v-384h21.334v384h-21.334z"></path>
                </svg>
            </span>
		</>
	)
}

function PlusIcon({width, height, className}) {
	return (
		<>
            <span className={className}>
                <svg viewBox="0 0 16 16" width={width} height={height} xmlns="http://www.w3.org/2000/svg"
                     className="fill-current">
                <path d="M14 7H9V2H7v5H2v2h5v5h2V9h5z"></path>
                <path fill="none" d="M0 0h16v16H0z"></path>
                </svg>
            </span>
		</>
	)
}

function HearthIcon({width, height, className}) {
	return (
		<>
            <span className={className}>
                <svg viewBox="0 0 16 16" width={width} height={height} xmlns="http://www.w3.org/2000/svg"
                     className="fill-current">
                    <path
	                    d="M13.797 2.727a4.057 4.057 0 00-5.488-.253.558.558 0 01-.31.112.531.531 0 01-.311-.112 4.054 4.054 0 00-5.487.253c-.77.77-1.194 1.794-1.194 2.883s.424 2.113 1.168 2.855l4.462 5.223a1.791 1.791 0 002.726 0l4.435-5.195a4.052 4.052 0 001.195-2.883 4.057 4.057 0 00-1.196-2.883z"></path>
                </svg>
            </span>
		</>
	)
}

function HearthEmptyIcon({width, height, className}) {
	return (
		<>
            <span className={className}>
                <svg viewBox="0 0 16 16" width={width} height={height} xmlns="http://www.w3.org/2000/svg"
                     className="fill-current">
                    <path
	                    d="M13.764 2.727a4.057 4.057 0 00-5.488-.253.558.558 0 01-.31.112.531.531 0 01-.311-.112 4.054 4.054 0 00-5.487.253A4.05 4.05 0 00.974 5.61c0 1.089.424 2.113 1.168 2.855l4.462 5.223a1.791 1.791 0 002.726 0l4.435-5.195A4.052 4.052 0 0014.96 5.61a4.057 4.057 0 00-1.196-2.883zm-.722 5.098L8.58 13.048c-.307.36-.921.36-1.228 0L2.864 7.797a3.072 3.072 0 01-.905-2.187c0-.826.321-1.603.905-2.187a3.091 3.091 0 012.191-.913 3.05 3.05 0 011.957.709c.041.036.408.351.954.351.531 0 .906-.31.94-.34a3.075 3.075 0 014.161.192 3.1 3.1 0 01-.025 4.403z"></path>
                </svg>
            </span>
		</>
	)
}

function PrevIcon({width, height, className}) {
	return (
		<>
            <span className={className}>
                <svg viewBox="0 0 24 24" width={width} height={height} xmlns="http://www.w3.org/2000/svg"
                     className="fill-current">
                    <polyline points="16 4 7 12 16 20" fill="none" className="stroke-current"
                              strokeWidth={1.5}></polyline>
                </svg>
            </span>
		</>
	)
}

function NextIcon({width, height, className}) {
	return (
		<>
            <span className={className}>
                <svg viewBox="0 0 24 24" width={width} height={height} xmlns="http://www.w3.org/2000/svg"
                     className="fill-current">
                    <polyline points="8 4 17 12 8 20" fill="none" className="stroke-current"
                              strokeWidth={1.5}></polyline>
                </svg>
            </span>
		</>
	)
}

function PlayIcon({width, height, className}) {
	return (
		<>
            <span className={className}>
                <svg viewBox="0 0 24 24" width={width} height={height} xmlns="http://www.w3.org/2000/svg"
                     className="fill-current">
                <polygon points="21.57 12 5.98 3 5.98 21 21.57 12"></polygon>
                </svg>
            </span>
		</>
	)
}

function MusicIcon({width, height, className}) {
	return (
		<>
            <span className={className}>
                <svg viewBox="-20 -25 100 100" width={width} height={height} xmlns="http://www.w3.org/2000/svg"
                     className="fill-current">
                    <path
	                    d="M16 7.494v28.362A8.986 8.986 0 0 0 9 32.5c-4.962 0-9 4.038-9 9s4.038 9 9 9 9-4.038 9-9V9.113l30-6.378v27.031a8.983 8.983 0 0 0-7-3.356c-4.962 0-9 4.038-9 9 0 4.963 4.038 9 9 9s9-4.037 9-9V.266L16 7.494zM9 48.5c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7c0 3.859-3.141 7-7 7zm32-6.09c-3.86 0-7-3.14-7-7 0-3.859 3.14-7 7-7s7 3.141 7 7c0 3.861-3.141 7-7 7z"
	                    fill="currentColor" fillRule="evenodd"></path>
                </svg>
            </span>
		</>
	)
}

function SignalIcon({width, height, className}) {
	return (
		<>
            <span className={className}>
                <svg viewBox="0 0 1024 1024" width={width} height={height} xmlns="http://www.w3.org/2000/svg"
                     className="fill-current">
                    <path
	                    d="M319.261 652.453q23.15 27.685 55.388 48.318l-27.685 32.22q-34.233-22.651-59.907-52.853-52.355-60.926-66.459-138.693t12.086-152.28 87.092-126.364q11.587-10.069 27.187-20.137l27.685 32.22q-16.122 10.584-27.187 20.137-52.355 44.804-74.759 108.476t-10.321 130.147 56.89 118.808zM865.98 185.789q60.422 70.994 88.843 158.315t20.904 179.986q-5.034 61.924-25.172 119.312t-54.621 107.725-81.809 90.629q-11.587 9.565-26.688 20.652l-27.685-32.22q15.103-10.584 27.187-20.652 63.923-55.388 101.944-129.632t44.804-158.83-19.119-164.116-80.812-143.979q-31.722-36.756-74.003-67.456l27.685-32.22q44.804 32.719 78.522 72.489zM190.382 762.714q31.722 36.756 74.003 67.456l-27.685 32.22q-44.3-32.719-78.522-72.489-60.422-70.994-88.843-158.315t-21.156-180.238 49.072-174.689 112.758-142.711q11.587-9.565 26.688-20.652l27.685 32.22q-15.103 10.584-27.187 20.652-64.942 55.892-102.691 132.145t-44.037 156.317 18.867 161.351 81.062 146.748zM512.061 360.97q52.355 0 89.61 37.254t37.254 89.61q0 46.823-30.206 82.058t-75.525 42.786v298.026h-42.288v-298.026q-29.702-5.034-53.854-22.651t-38.001-44.552-13.832-57.638q0-52.355 37.254-89.61t89.61-37.254zM512.061 572.408q35.241 0 59.907-24.92t24.668-59.655-24.92-59.655-59.655-24.92-59.655 24.92-24.92 59.655q0 23.15 11.338 42.537t30.721 30.721 42.537 11.338zM737.104 295.533q52.355 60.926 66.459 138.693t-12.086 152.28-87.092 126.364q-11.587 10.069-27.187 20.652l-27.685-32.719q16.122-10.584 27.187-20.137 52.355-44.3 74.759-108.224t10.321-130.399-56.89-118.808q-23.15-27.685-55.388-48.318l27.685-32.22q33.718 22.651 59.907 52.853z"
	                    fill="currentColor" fillRule="evenodd"></path>
                </svg>
            </span>
		</>
	)
}

function PipIcon({width, height, className}) {
	return (
		<>
            <span className={className}>
                <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg"
                     className="fill-current">
	                    <path
		                    d="M1 3v9h14V3H1zm0-1h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z"
		                    fillRule="nonzero"></path>
	                    <path d="M10 8h4v3h-4z"></path>
                </svg>
            </span>
		</>
	)
}

function ShuffleIcon({width, height, className}) {
	return (
		<>
            <span className={className}>
                <svg viewBox="0 0 16 16" width={width} height={height} xmlns="http://www.w3.org/2000/svg"
                     className="fill-current">
	                    <path d="M4.5 6.8l.7-.8C4.1 4.7 2.5 4 .9 4v1c1.3 0 2.6.6 3.5 1.6l.1.2zm7.5 4.7c-1.2 0-2.3-.5-3.2-1.3l-.6.8c1 1 2.4 1.5 3.8 1.5V14l3.5-2-3.5-2v1.5zm0-6V7l3.5-2L12 3v1.5c-1.6 0-3.2.7-4.2 2l-3.4 3.9c-.9 1-2.2 1.6-3.5 1.6v1c1.6 0 3.2-.7 4.2-2l3.4-3.9c.9-1 2.2-1.6 3.5-1.6z"></path>
                </svg>
            </span>
		</>
	)
}

function RepeatIcon({width, height, className}) {
	return (
		<>
            <span className={className}>
                <svg viewBox="0 0 16 16" width={width} height={height} xmlns="http://www.w3.org/2000/svg"
                     className="fill-current">
	                <path d="M5.5 5H10v1.5l3.5-2-3.5-2V4H5.5C3 4 1 6 1 8.5c0 .6.1 1.2.4 1.8l.9-.5C2.1 9.4 2 9 2 8.5 2 6.6 3.6 5 5.5 5zm9.1 1.7l-.9.5c.2.4.3.8.3 1.3 0 1.9-1.6 3.5-3.5 3.5H6v-1.5l-3.5 2 3.5 2V13h4.5C13 13 15 11 15 8.5c0-.6-.1-1.2-.4-1.8z"></path>
                </svg>
            </span>
		</>
	)
}

function PlayerPrevIcon({width, height, className}) {
	return (
		<>
            <span className={className}>
                <svg viewBox="0 0 16 16" width={width} height={height} xmlns="http://www.w3.org/2000/svg"
                     className="fill-current">
	                <path d="M13 2.5L5 7.119V3H3v10h2V8.881l8 4.619z"></path>
                </svg>
            </span>
		</>
	)
}

function PlayerNextIcon({width, height, className}) {
	return (
		<>
            <span className={className}>
                <svg viewBox="0 0 16 16" width={width} height={height} xmlns="http://www.w3.org/2000/svg"
                     className="fill-current">
	                <path d="M11 3v4.119L3 2.5v11l8-4.619V13h2V3z"></path>
                </svg>
            </span>
		</>
	)
}

function DeviceIcon({width, height, className}) {
	return (
		<>
            <span className={className}>
                <svg viewBox="0 0 16 16" width={width} height={height} xmlns="http://www.w3.org/2000/svg"
                     className="fill-current">
	                <path d="M0 3v8c0 .55.45 1 1 1h5v-1H1V3h5V2H1c-.55 0-1 .45-1 1zm3 11.5c0 .275.225.5.5.5H6v-1H3.5c-.275 0-.5.225-.5.5zM15 2H9c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm0 12H9V3h6v11zm-3-8a.75.75 0 100-1.5.75.75 0 000 1.5zm0 6a2 2 0 100-4 2 2 0 000 4zm0-3c.551 0 1 .449 1 1s-.449 1-1 1-1-.449-1-1 .449-1 1-1z"></path>
                </svg>
            </span>
		</>
	)
}

function SoundIcon({width, height, className}) {
	return (
		<>
            <span className={className}>
                <svg viewBox="0 0 16 16" width={width} height={height} xmlns="http://www.w3.org/2000/svg"
                     className="fill-current">
	                <path d="M12.945 1.379l-.652.763c1.577 1.462 2.57 3.544 2.57 5.858s-.994 4.396-2.57 5.858l.651.763a8.966 8.966 0 00.001-13.242zm-2.272 2.66l-.651.763a4.484 4.484 0 01-.001 6.397l.651.763c1.04-1 1.691-2.404 1.691-3.961s-.65-2.962-1.69-3.962zM0 5v6h2.804L8 14V2L2.804 5H0zm7-1.268v8.536L3.072 10H1V6h2.072L7 3.732z"></path>
                </svg>
            </span>
		</>
	)
}

function FullSreenIcon({width, height, className}) {
	return (
		<>
            <span className={className}>
                <svg viewBox="0 0 16 16" width={width} height={height} xmlns="http://www.w3.org/2000/svg"
                     className="fill-current">
	                <path d="M6.064 10.229l-2.418 2.418L2 11v4h4l-1.647-1.646 2.418-2.418-.707-.707zM11 2l1.647 1.647-2.418 2.418.707.707 2.418-2.418L15 6V2h-4z"></path>
                </svg>
            </span>
		</>
	)
}

function DownloadIcon({width, height, className}) {
	return (
		<>
            <span className={className}>
                <svg viewBox="0 0 24 24" width={width} height={height} xmlns="http://www.w3.org/2000/svg"
                     className="fill-current">
	                <path d="M11.5 0C5.149 0 0 5.148 0 11.5 0 17.851 5.149 23 11.5 23S23 17.851 23 11.5C23 5.148 17.851 0 11.5 0zm0 22C5.71 22 1 17.29 1 11.5S5.71 1 11.5 1 22 5.71 22 11.5 17.29 22 11.5 22zm.499-6.842V5h-1v10.149l-3.418-3.975-.758.652 4.678 5.44 4.694-5.439-.757-.653-3.439 3.984z"></path>
                </svg>
            </span>
		</>
	)
}

function DirDownIcon({width, height, className}) {
	return (
		<>
            <span className={className}>
                <svg viewBox="0 0 16 16" width={width} height={height} xmlns="http://www.w3.org/2000/svg"
                     className="fill-current">
	                <path d="M3 6l5 5.794L13 6z"></path>
                </svg>
            </span>
		</>
	)
}

function PauseIcon({width, height, className}) {
	return (
		<>
            <span className={className}>
                <svg viewBox="0 0 24 24" width={width} height={height} xmlns="http://www.w3.org/2000/svg"
                     className="fill-current">
	                <rect x="5" y="3" width="4" height="18"></rect>
	                <rect x="15" y="3" width="4" height="18"></rect>
                </svg>
            </span>
		</>
	)
}

function ArrowDownIcon({width, height, className}) {
	return (
		<>
            <span className={className}>
                <svg viewBox="0 0 24 24" width={width} height={height} xmlns="http://www.w3.org/2000/svg"
                     className="fill-current">
	                <polygon points="7.96,21.151 7.311,20.39 16.865,12.229 7.311,4.069 7.96,3.309 18.405,12.229 "></polygon>
                </svg>
            </span>
		</>
	)
}

function Icon({src, size = 24, fill = '', className = 'fill-current'}) {

	const icons = {
		home: HomeIcon,
		search: SearchIcon,
		collection: CollectionIcon,
		plus: PlusIcon,
		hearth: HearthIcon,
		hearthEmpty: HearthEmptyIcon,
		prev: PrevIcon,
		next: NextIcon,
		play: PlayIcon,
		music: MusicIcon,
		signal: SignalIcon,
		pip: PipIcon,
		shuffle: ShuffleIcon,
		repeat: RepeatIcon,
		playerPrev: PlayerPrevIcon,
		playerNext: PlayerNextIcon,
		device: DeviceIcon,
		sound: SoundIcon,
		fullScreen: FullSreenIcon,
		download: DownloadIcon,
		dirDown: DirDownIcon,
		pause: PauseIcon,
		arrowDown: ArrowDownIcon
	}

	const DynamicComponent = icons[src]
	return <DynamicComponent width={size} height={size} fill={fill} className={className}/>
}

export {
	Icon,
}